import { createBrowserRouter, Navigate } from 'react-router-dom';
import { HomePage } from '@/app/HomePage';
import { BlockedPage, CompletionPage, CostPage, NarrationQaPage } from '@/app/AxisPages';
import {
  RunDetailPage,
  RunListPage,
  SceneDetailPage,
  SceneListPage,
} from '@/app/ExplorePages';
import { LoginPage, RequireAuth } from '@/app/LoginPage';
import { SettingsPage } from '@/app/SettingsPage';
import { TokenPreview } from '@/app/TokenPreview';

/**
 * 라우트.
 *
 * ★ 경로는 현재 Flutter 앱과 **같은 이름**으로 잡는다 — 배포를 갈아탈 때
 *   북마크와 SORO 딥링크가 그대로 살아야 한다.
 * ⚠️ 상세는 경로 파라미터를 받는다. 원본은 페이지 파라미터(`runId`·`sceneId`)다.
 * ⚠️ 없는 경로는 개요로 보낸다 — 404 보다 낫다.
 */
export const router = createBrowserRouter([
  { path: '/', element: <RequireAuth><HomePage /></RequireAuth> },
  { path: '/completion', element: <RequireAuth><CompletionPage /></RequireAuth> },
  { path: '/blocked', element: <RequireAuth><BlockedPage /></RequireAuth> },
  { path: '/narrationQa', element: <RequireAuth><NarrationQaPage /></RequireAuth> },
  { path: '/cost', element: <RequireAuth><CostPage /></RequireAuth> },
  { path: '/runList', element: <RequireAuth><RunListPage /></RequireAuth> },
  { path: '/runDetail/:runId', element: <RequireAuth><RunDetailPage /></RequireAuth> },
  { path: '/sceneList', element: <RequireAuth><SceneListPage /></RequireAuth> },
  { path: '/sceneDetail/:sceneId', element: <RequireAuth><SceneDetailPage /></RequireAuth> },
  { path: '/settings', element: <RequireAuth><SettingsPage /></RequireAuth> },
  // ⚠️ 로그인과 토큰 점검에는 게이트를 걸지 않는다 — 걸면 들어올 수 없다.
  { path: '/login', element: <LoginPage /> },
  { path: '/_tokens', element: <TokenPreview /> },
  { path: '*', element: <Navigate to="/" replace /> },
]);
